import { useTranslation } from 'react-i18next';
import { LOCALES } from '../common/constants';

export const useLocale = () => {
  const { i18n } = useTranslation();

  const getCurrentLocale = (): LOCALES => {
    return i18n.language === 'fi' ? LOCALES.Fi : LOCALES.En;
  };

  return {
    currentLocale: getCurrentLocale(),
    getCurrentLocale,
  };
};
